export const money = (i: number): string => {
  return `$${(i / 100).toFixed(2)}`;
};

export default money;
